import { ZfBox, ZfDivider, ZfTextButton } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';
import { getImageUrlByString } from '../../../../styles/assets/imageMap';
import { useTopic } from '../../../api';
import type { TopicDto } from '../../../api/generated/client';
import { useNeedContentContext } from '../../../contexts/need-content-context';
import { useContainerDimensions } from '../../../hooks/useContainerDimensions';
import { buildPanelProps } from '../../../utils/topicUtils';
import { TopicListSidebar } from '../components/TopicListSidebar';
import { TopicPanel } from '../panels/TopicPanel';

export const TopicScreenActiveSession: FunctionComponent = () => {
    const { t, i18n } = useTranslation();
    const containerDimensions = useContainerDimensions();
    const { activeTalkingPoint, activeAdvisoryNeed } = useNeedContentContext();
    const { topicId } = useParams();
    const { data: topic } = useTopic(Number(topicId));
    const navigate = useNavigate();

    if (!topic) {
        return null;
    }

    return (
        <ZfBox id="topicScreen" style={{ flex: 1 }}>
            <div className="topic-screen" style={{ height: `${containerDimensions.height}px` }}>
                <div className="topic-screen__sidebar">
                    <div className="topic-screen__sidebar__header">
                        <ZfTextButton hierarchy="tertiary" size="small" leading-icon="arrow_back" className="m-auto-0" onClick={() => navigate('..')}>
                            {t('back')}
                        </ZfTextButton>
                        <ZfDivider orientation="vertical" />
                        <h4>{topic.name[i18n.language]}</h4>
                    </div>
                    <div className="topic-screen__sidebar__header-title">
                        <h5>{t('titleKeyTopics')}</h5>
                        <small>{t('subTitleKeyTopics')}</small>
                    </div>
                    <TopicListSidebar showLeadingCheckbox={true} />
                </div>
                <div className="topic-screen__panels" style={{ backgroundImage: `url(${getImageUrlByString(topic.key)})` }}>
                    <TopicPanel {...buildPanelProps(topic as TopicDto, containerDimensions.height, activeTalkingPoint, activeAdvisoryNeed, false, false)} />
                </div>
            </div>
        </ZfBox>
    );
};
